// [id: string, quantity: int]
async function addItemsToCart(items) {
  console.log("Adding items to cart:", items);
  const addUrl = `${window.Shopify.routes.root}cart/add.js`;

  if (items.length > 0) {
    try {
      const data = await fetch(addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
      });
      return data;
    } catch (error) {
      console.error("Error adding items to cart:", items, error);
    }
  }
}

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

function clearCart() {
  return fetch(`${window.Shopify.routes.root}cart/clear.js`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
}
function formatMoney(number, decPlaces, decSep, thouSep) {
  (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
    (decSep = typeof decSep === "undefined" ? "." : decSep);
  thouSep = typeof thouSep === "undefined" ? "," : thouSep;
  var sign = number < 0 ? "-" : "";
  var i = String(
    parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
  );
  var j = i.length > 3 ? i.length % 3 : 0;

  return (
    sign +
    (j ? i.substr(0, j) + thouSep : "") +
    i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
    (decPlaces
      ? decSep +
        Math.abs(number - i)
          .toFixed(decPlaces)
          .slice(2)
      : "")
  );
}

window.NttUtils = window.NttUtils ?? {};
window.NttUtils.addItemsToCart = addItemsToCart;
window.NttUtils.getUrlParameter = getUrlParameter;
window.NttUtils.formatMoney = formatMoney;
window.NttUtils.clearCart = clearCart;
